import pure from "./higher-order/pure";
import React from "react";
import TicketTable from "./ticket-table";

export default pure(function EntrantPicksPopup({ children, deadHeat, position, raceEntrant, tickets, users }) {
  var deadHeatElem;
  if (deadHeat) {
    deadHeatElem = (
      <div className="color--is-medium-gray">
        Dead Heat
      </div>
    );
  }
  var title = raceEntrant.get("horse_name");
  if (position) {
    title += " finished " + position + "!";
  }
  return (
    <div className="popup">
      <div className="popup_content">
        <div className="popup_title">
          {deadHeatElem}

          <div>
            {title}
          </div>
        </div>

        <div className="popup_body">
          <p>
            {tickets.count()}

            {" "}

            {tickets.count() === 1 ? "player" : "players"}

            {" "}
            picked this horse.
          </p>

          <TicketTable tickets={tickets} users={users} />
        </div>
      </div>

      {children}
    </div>
  );
});
